import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psychological-support',
  templateUrl: './psychological-support.component.html',
  styleUrls: ['./psychological-support.component.css'],
})
export class PsychologicalSupportComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
